import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        formControl: {
            width: '100%',
        },
        link: {
            color: theme.palette.primary.dark,
        },
        noFile: {
            color: theme.palette.secondary.main,
            fontSize: theme.typography.h5.fontSize,
        },
        container: {
            display: 'flex',
            width: '100%',
            gap: 5,
            alignItems: 'center',
        },
        label: {
            flexGrow: 1,
            flexShrink: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        icon: {
            '&&': {
                flexBasis: 34,
            },
        },
    }
})

export default useStyles
